import tierPopupSaga from './tierPopupSaga';
import tierManageContentSaga from './tierManageContentSaga';
import tierManageContentReducer from './tierManageContentReducer';
import tierListSaga from './tierListSaga';
import tipJarSaga from './tipJarSaga';
import tierListReducer from './tierListReducer';
import tierPopupReducer from './tierPopupReducer';
import { reduxModuleLoaded, requestTiers } from './actions';
import { tierManageContentReduxKey, tierListReduxKey, tierPopupReduxKey, } from './constants';
export function getModule() {
    var _a;
    return {
        id: 'tierCreator',
        reducerMap: (_a = {},
            _a[tierManageContentReduxKey] = tierManageContentReducer,
            _a[tierListReduxKey] = tierListReducer,
            _a[tierPopupReduxKey] = tierPopupReducer,
            _a),
        sagas: [tierPopupSaga, tierManageContentSaga, tierListSaga, tipJarSaga],
        initialActions: [reduxModuleLoaded(), requestTiers()],
        retained: true,
    };
}
//# sourceMappingURL=module.js.map